import { render } from "./UserDocuments.vue?vue&type=template&id=15ed8994&scoped=true"
import script from "./UserDocuments.vue?vue&type=script&lang=js"
export * from "./UserDocuments.vue?vue&type=script&lang=js"

import "./UserDocuments.vue?vue&type=style&index=0&id=15ed8994&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ed8994"]])

export default __exports__